import $ from 'jquery';

import AlerterView from 'chairisher/view/alerter';
import BaseController from 'chairisher/_controller';
import ImageCarousel from 'chairisher/component/imagecarousel';
import ModalViewHelper from 'chairisher/view/helper/modal';
import RepeatingScroller from 'chairisher/component/scroller/repeating';
import RewardDashboardView from 'chairisher/view/reward/dashboard';
import UriUtils from 'chairisher/util/uri';

import bindBackToTop from 'chairisher/component/backtotop';
import bindInlineEmailSignup from 'chairisher/view/promo/inlineemailsignup';
import createProductRail from 'chairisher/view/helper/rail';
import getCarouselStories from 'chairisher/context/carousel';
import trackHomepageScreen from 'chairisher/analytics/homepage';

import { trackDesignerBusinessImpressions } from 'chairisher/analytics/business/search';
import { trackSuccessfulEmailPanelCollection } from 'chairisher/analytics/email';
import { isTrade, isVip } from 'chairisher/context/auth';
import { getBusinessRailData, getBusinessRailEndpoint, setBusinessRailData } from 'chairisher/context/business';
import { getRecentlyViewedUrl } from 'chairisher/context/product';
import { getPromotedListingsUrl } from 'chairisher/context/promotedlistings';
import { getSustainabilityKpi } from 'chairisher/context/site';
import {
    AmplitudeEventProperty,
    ProductRailPosition,
    ProductRailType,
    SellerPlanAction,
    SellerPlanType,
    UhpPosition,
    logAmplitudeEvent,
} from 'chairisher/util/analytics';
import { isMinMediumDesktop, prefersReducedMotion } from 'chairisher/util/mediaquery';
import { observeIntersectionOnce } from 'chairisher/view/helper/intersectionobserver';
import { CountUp } from 'countup';

/**
 * Controller that binds actions for the UHP
 */
class HomepageController extends BaseController {
    /** @inheritDoc * */
    bindPageAnalytics() {
        super.bindPageAnalytics();
        trackHomepageScreen();
    }

    /** @inheritDoc * */
    bindChairishActions() {
        super.bindChairishActions();

        const carouselStories = getCarouselStories();
        if (carouselStories.length > 0) {
            const imageCarousel = new ImageCarousel({
                elClass: 'js-hero-story-carousel',
                externalData: carouselStories,
                position: UhpPosition.HERO,
            });
            imageCarousel.bind();
        }

        const shouldAutoScroll = isMinMediumDesktop();

        // new arrivals scroller
        const $container = $('#js-new-arrival-grid');
        if ($container.length) {
            RepeatingScroller.createProductScroller($container, {
                analyticsTrackingType: ProductRailType.NEW_ARRIVALS,
                shouldAutoScroll,
            });
        }

        // add recently viewed above fold rail
        const rvAboveFoldProductsIdSelector = '#js-recently-viewed-above-fold';
        createProductRail({
            $containerEl: $(rvAboveFoldProductsIdSelector),
            $el: $(`${rvAboveFoldProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.TOP,
            analyticsTrackingType: ProductRailType.RECENTLY_VIEWED,
            listSelector: rvAboveFoldProductsIdSelector,
            railUrl: getRecentlyViewedUrl(),
        });

        const $wholesaleContainer = $('#js-wholesale-featured-grid');
        if ($wholesaleContainer.length) {
            RepeatingScroller.createProductScroller($wholesaleContainer, {
                analyticsTrackingType: ProductRailType.WHOLESALE,
                shouldAutoScroll,
            });
        }

        bindInlineEmailSignup({
            captureType: 'panel',
            formSelector: '#js-chairish-inline-email-collector-form',
            emailTrackingCallback() {
                trackSuccessfulEmailPanelCollection();
            },
        });

        if (isTrade() || isVip()) {
            const rewardDashboardView = new RewardDashboardView($('.js-reward-dashboard'));
            rewardDashboardView.bind();
        }

        observeIntersectionOnce('.js-uhp-designer-search', () => {
            $.ajax({
                url: getBusinessRailEndpoint(),
            }).done((response) => {
                $('.js-uhp-designer-search .js-color-block-inner').html(response.html);
                setBusinessRailData(response.business_json);
                $.each(getBusinessRailData(), (_, businessData) => {
                    trackDesignerBusinessImpressions(
                        UhpPosition.DESIGNER_DIRECTORY,
                        businessData.is_dma_match,
                        businessData.absolute_url,
                    );
                });
            });
        });

        if (!prefersReducedMotion()) {
            const countTargetId = 'js-sustainability-kpi';
            observeIntersectionOnce(`#${countTargetId}`, () => {
                const countUp = new CountUp(countTargetId, getSustainabilityKpi());
                countUp.start();
            });
        }

        if (UriUtils.extractParamFromUri(document.location.search, 'platinum-application-success')) {
            logAmplitudeEvent(SellerPlanAction.APPLICATION_SUCCESS, {
                [AmplitudeEventProperty.SELLER_PLAN_NAME]: SellerPlanType.PLATINUM,
            });

            AlerterView.success("Thank you for applying to be a Platinum Seller — we'll reach out soon.");
        }

        if (UriUtils.extractParamFromUri(document.location.search, 'lead-created')) {
            ModalViewHelper.renderModalFromTemplate('#js-business-application-confirmation-modal');
            logAmplitudeEvent('business register - success');
        }

        this.bindFeaturedNewArrivalsProducts();

        bindBackToTop();
    }

    bindFeaturedNewArrivalsProducts() {
        const featuredTopProductsIdSelector = '#js-featured-new-arrivals-products-top-rail';
        createProductRail({
            $containerEl: $(featuredTopProductsIdSelector),
            $el: $(`${featuredTopProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.TOP,
            analyticsTrackingType: ProductRailType.NEW_ARRIVALS,
            listSelector: featuredTopProductsIdSelector,
            railUrl: getPromotedListingsUrl(),
            shouldShowDetails: false,
        });

        const featuredBottomProductsIdSelector = '#js-featured-new-arrivals-products-bottom-rail';
        createProductRail({
            $containerEl: $(featuredBottomProductsIdSelector),
            $el: $(`${featuredBottomProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.BOTTOM,
            analyticsTrackingType: ProductRailType.NEW_ARRIVALS,
            listSelector: featuredBottomProductsIdSelector,
            railUrl: getPromotedListingsUrl(),
            shouldShowDetails: false,
        });
    }
}

export default HomepageController;
